// Backend API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: `${API_BASE_URL}/auth/login`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  GET_ME: `${API_BASE_URL}/auth/me`,
  UPDATE_PROFILE: `${API_BASE_URL}/auth/update-profile`,
  CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,

  // Courses
  COURSES: `${API_BASE_URL}/courses`,
  FEATURED_COURSES: `${API_BASE_URL}/courses/featured`,
  COURSE_CATEGORIES: `${API_BASE_URL}/courses/meta/categories`,
  COURSE_BY_SLUG: (slug) => `${API_BASE_URL}/courses/${slug}`,
  CREATE_COURSE: `${API_BASE_URL}/courses`,
  UPDATE_COURSE: (id) => `${API_BASE_URL}/courses/${id}`,
  DELETE_COURSE: (id) => `${API_BASE_URL}/courses/${id}`,

  // Blogs
  BLOGS: `${API_BASE_URL}/blogs`,
  FEATURED_BLOGS: `${API_BASE_URL}/blogs/featured`,
  BLOG_CATEGORIES: `${API_BASE_URL}/blogs/meta/categories`,
  BLOG_TAGS: `${API_BASE_URL}/blogs/meta/tags`,
  BLOG_BY_SLUG: (slug) => `${API_BASE_URL}/blogs/${slug}`,
  CREATE_BLOG: `${API_BASE_URL}/blogs`,
  UPDATE_BLOG: (id) => `${API_BASE_URL}/blogs/${id}`,
  DELETE_BLOG: (id) => `${API_BASE_URL}/blogs/${id}`,
  INCREMENT_BLOG_VIEWS: (id) => `${API_BASE_URL}/blogs/${id}/views`,

  // Testimonials
  TESTIMONIALS: `${API_BASE_URL}/testimonials`,
  FEATURED_TESTIMONIALS: `${API_BASE_URL}/testimonials/featured`,
  TESTIMONIAL_BY_ID: (id) => `${API_BASE_URL}/testimonials/${id}`,
  CREATE_TESTIMONIAL: `${API_BASE_URL}/testimonials`,
  UPDATE_TESTIMONIAL: (id) => `${API_BASE_URL}/testimonials/${id}`,
  DELETE_TESTIMONIAL: (id) => `${API_BASE_URL}/testimonials/${id}`,

  // Users
  USERS: `${API_BASE_URL}/users`,
  USER_STATS: `${API_BASE_URL}/users/stats`,
  USER_BY_ID: (id) => `${API_BASE_URL}/users/${id}`,
  CREATE_USER: `${API_BASE_URL}/users`,
  UPDATE_USER: (id) => `${API_BASE_URL}/users/${id}`,
  DELETE_USER: (id) => `${API_BASE_URL}/users/${id}`,

  // Contact Forms
  CONTACT: `${API_BASE_URL}/contact`,
  CONTACT_BY_ID: (id) => `${API_BASE_URL}/contact/${id}`,
  UPDATE_CONTACT: (id) => `${API_BASE_URL}/contact/${id}`,
  DELETE_CONTACT: (id) => `${API_BASE_URL}/contact/${id}`,

  // Course Enrollments
  ENROLLMENTS: `${API_BASE_URL}/enrollments`,
  ENROLLMENT_STATS: `${API_BASE_URL}/enrollments/stats`,
  ENROLLMENT_BY_ID: (id) => `${API_BASE_URL}/enrollments/${id}`,
  CREATE_ENROLLMENT: `${API_BASE_URL}/enrollments`,
  UPDATE_ENROLLMENT: (id) => `${API_BASE_URL}/enrollments/${id}`,
  DELETE_ENROLLMENT: (id) => `${API_BASE_URL}/enrollments/${id}`,

  // File Upload
  UPLOAD_IMAGE: `${API_BASE_URL}/upload/image`,
  UPLOAD_IMAGES: `${API_BASE_URL}/upload/images`,
  DELETE_IMAGE: `${API_BASE_URL}/upload/image`,

  // Hero Slides
  HERO_SLIDES: `${API_BASE_URL}/hero-slides`,
  HERO_SLIDE_BY_ID: (id) => `${API_BASE_URL}/hero-slides/${id}`,
  CREATE_HERO_SLIDE: `${API_BASE_URL}/hero-slides`,
  UPDATE_HERO_SLIDE: (id) => `${API_BASE_URL}/hero-slides/${id}`,
  DELETE_HERO_SLIDE: (id) => `${API_BASE_URL}/hero-slides/${id}`,
  UPDATE_SLIDES_ORDER: `${API_BASE_URL}/hero-slides/order/update`,

  // Partners
  PARTNERS: `${API_BASE_URL}/partners`,
  PARTNERS_ALL: `${API_BASE_URL}/partners/all`,
  PARTNER_BY_ID: (id) => `${API_BASE_URL}/partners/${id}`,
  CREATE_PARTNER: `${API_BASE_URL}/partners`,
  UPDATE_PARTNER: (id) => `${API_BASE_URL}/partners/${id}`,
  DELETE_PARTNER: (id) => `${API_BASE_URL}/partners/${id}`,
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  // Try admin token first, then fall back to regular token
  const token = localStorage.getItem('admin_jwt') || localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

// Helper function for multipart form data (file uploads)
export const getAuthHeadersMultipart = () => {
  // Try admin token first, then fall back to regular token
  const token = localStorage.getItem('admin_jwt') || localStorage.getItem('token');
  return {
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

// Helper function to handle API errors
export const handleApiError = (error) => {
  if (error.response) {
    // Server responded with error
    return error.response.data.message || 'An error occurred';
  } else if (error.request) {
    // Request made but no response
    return 'Network error. Please check your connection.';
  } else {
    // Something else happened
    return error.message || 'An error occurred';
  }
};

export { API_BASE_URL };
